import { Navigate, Route, Routes } from 'react-router-dom';
import AllMetricsRedesign from 'views/Results/Insights/AllMetrics';
import { SubMetricDetail } from 'views/Results/Insights/SubMetricDetail/SubMetricDetail';

export const MetricsRoutes = () => {
  return (
    <Routes>
      <Route path={``} element={<Navigate to={`all-metrics`} replace />} />
      <Route path={`all-metrics`} element={<AllMetricsRedesign />} />
      <Route
        path={`:category/:subMetricId`}
        element={<SubMetricDetail key='insights-submetric-detail' />}
      />
    </Routes>
  );
};
